import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { declineProposition, acceptProposition, confirmAcceptance } from "../../redux/actions/propositionActions";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import PaymentForm from "../PaymentForm";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

const PropositionCard = ({ proposition }) => {
    const { token } = useSelector((state) => state.auth);
    const dispatch = useDispatch();

    const [isAccepting, setIsAccepting] = useState(false);
    const [clientSecret, setClientSecret] = useState(null);
    const [showPayment, setShowPayment] = useState(false);
    const [paymentIntentId, setPaymentIntentId] = useState(null);

    if (!proposition) return null;

    const {
        idProposition,
        titre,
        descriptionProposition,
        montantHT,
        tauxTVA,
        montantTTC,
        statut,
        createdAt,
        commissionClient,
        commissionFee,
        totalCommission,
        devisFileName,
    } = proposition;


    const handleAcceptClick = async () => {
        if (isAccepting) return; // 🔒 Empêche double appel
        setIsAccepting(true);

        try {
            // Appel backend pour créer le PaymentIntent et récupérer clientSecret
            const response = await dispatch(acceptProposition(idProposition, token));
            setClientSecret(response.clientSecret);
            setPaymentIntentId(response.paymentIntentId); // 🔹 stocker l'id

            setShowPayment(true);
        } catch (error) {
            alert("Erreur lors de l'acceptation : " + error.message);
        } finally {
            setIsAccepting(false);
        }
    };

    const handlePaymentSuccess = async () => {
        try {
            // 🔑 Le dispatch confirmAcceptance ne se fait qu'ici
            await dispatch(confirmAcceptance(idProposition,paymentIntentId, token));
            setShowPayment(false);
            alert("Proposition acceptée et paiement effectué !");
        } catch (error) {
            alert("Erreur lors de la confirmation : " + error.message);
        }
    };

    return (
        <div style={{ borderRadius: "12px", padding: "20px", background: "#fff", boxShadow: "0 4px 15px rgba(0,0,0,0.1)", marginBottom: "20px" }}>
            <h2 style={{ margin: 0, marginBottom: "10px", fontSize: "20px" }}>{titre}</h2>

            <hr style={{ margin: "15px 0" }} />
            <h3>Description :</h3>
            <p style={{ marginBottom: "15px", lineHeight: "1.5" }}>{descriptionProposition}</p>

            <div style={{ marginBottom: "15px" }}>
                <strong>Montant HT :</strong> {montantHT} €<br />
                <strong>TVA :</strong> {tauxTVA}%<br />
                <strong>Total TTC :</strong> {montantTTC} €<br />
                <p>Si vous acceptez cette proposition, ce montant devra être réglé directement au prestataire selon ses conditions de paiement.</p>
            </div>

            {commissionClient !== null && (
                <div style={{ marginBottom: "15px" }}>
                    <strong>Commission :</strong> {commissionClient} €<br />
                    <strong>Frais de service :</strong> {commissionFee} €<br />
                    <strong>Total :</strong> {totalCommission} €<br />
                    <p>Pour valider cette proposition, vous devrez régler la commission ainsi que les frais de service à INTERESEAUX via notre formulaire de paiement.</p>
                </div>
            )}

            <div style={{ fontSize: "14px", color: "#666", marginBottom: "15px" }}>
                Créée le : {createdAt}
            </div>

            {devisFileName && (
                <a
                    href={`${process.env.REACT_APP_API_URL}/api/files?categorie=propositions&file=${devisFileName}&download=1`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ display: "inline-block", padding: "8px 12px", backgroundColor: "#007bff", color: "#fff", borderRadius: "6px", textDecoration: "none", marginBottom: "10px" }}
                >
                    Télécharger le devis
                </a>
            )}

            <div style={{ marginTop: "15px" }}>
                {statut === "pending" && !showPayment && (
                    <>
                        <button onClick={handleAcceptClick} style={{ padding: "8px 12px", marginRight: "10px", borderRadius: "6px", border: "none", backgroundColor: "#4CAF50", color: "white", cursor: "pointer" }}>
                            Accepter
                        </button>

                        <button onClick={() => dispatch(declineProposition(token, proposition))} style={{ padding: "8px 12px", borderRadius: "6px", border: "none", backgroundColor: "#f44336", color: "white", cursor: "pointer" }}>
                            Refuser
                        </button>
                    </>
                )}

                {showPayment && clientSecret && (
                    <Elements stripe={stripePromise}>
                        <PaymentForm clientSecret={clientSecret} onSuccess={handlePaymentSuccess} />
                    </Elements>
                )}
            </div>
        </div>
    );
};

export default PropositionCard;
